import React from 'react';
import UploadedImage from './UploadedImage';
import UploadedVideo from './UploadedVideo';

type Props = {
  type: 'image' | 'video';
  url: string;
  publicFile?: boolean;
};

const UploadedItem: React.FC<Props> = ({ type, url, publicFile }) => {
  return type === 'image' ? (
    <UploadedImage url={url} publicFile={publicFile} />
  ) : type === 'video' ? (
    <UploadedVideo url={url} />
  ) : (
    <>Invalid upload.</>
  );
};

export default UploadedItem;
